import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    useTheme,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import React from 'react';
import { ModalProps } from '../../../types/modal';

interface Props extends ModalProps {
    onSubmit: () => void;
}

const CancelModal = ({ open, onClose, onSubmit }: Props) => {
    const theme = useTheme();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            disableRestoreFocus
            sx={{ zIndex: theme.zIndex.tooltip }}
        >
            <DialogTitle>
                Confirmation
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Alert severity='warning'>
                    You have unsaved changes. Are you sure you want to leave?
                </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button variant='contained' onClick={onSubmit}>
                    Leave
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CancelModal;
